import { Roles } from '@common/types/user';
import { IntlShape } from 'react-intl';

const ROLE_TO_NAME_MAP = (intl: IntlShape) =>
    new Map<Roles, string>([
        [Roles.VICTRON, intl.formatMessage({ id: 'role.administrator', defaultMessage: 'Administrator' })],
        [Roles.SALES_MANAGER, intl.formatMessage({ id: 'role.salesManager', defaultMessage: 'Sales Manager' })],
        [Roles.SALES_DIRECTOR, intl.formatMessage({ id: 'role.salesDirector', defaultMessage: 'Sales Director' })],
        [Roles.INSTALLER, intl.formatMessage({ id: 'role.installer', defaultMessage: 'Installer' })],
        [
            Roles.AUTHORIZED_INSTALLER,
            intl.formatMessage({ id: 'role.authorizedInstaller', defaultMessage: 'Authorized Installer' }),
        ],
        [Roles.DEALER, intl.formatMessage({ id: 'role.dealer', defaultMessage: 'Dealer' })],
        [Roles.DISTRIBUTOR, intl.formatMessage({ id: 'role.distributor', defaultMessage: 'Distributor' })],
        [Roles.END_USER, intl.formatMessage({ id: 'role.endUser', defaultMessage: 'End User' })],
        [Roles.UNREGISTERED, intl.formatMessage({ id: 'role.unregistered', defaultMessage: 'Unregistered User' })],
        [Roles.AMBASSADOR, intl.formatMessage({ id: 'role.ambassador', defaultMessage: 'Ambassador' })],
    ]);

export { ROLE_TO_NAME_MAP };
